import { HttpContext, HttpContextToken } from "@angular/common/http";

/**
 * Opt-out for the global error toast (ROR-5755): the form that sends the request
 * renders backend validation errors (400 / 422) inline itself.
 */
export const HANDLE_VALIDATION_INLINE = new HttpContextToken<boolean>(() => false);

export function inlineValidationContext(): HttpContext {
  return new HttpContext().set(HANDLE_VALIDATION_INLINE, true);
}
